/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportsFeatureFlagsWithDefaults extends models.FeatureFlagsWithDefaults {
    getFixupPrototypeFunction() { return ReportsFeatureFlagsWithDefaults.fixupPrototype; }

    static newInstance(model: Partial<ReportsFeatureFlagsWithDefaults>): ReportsFeatureFlagsWithDefaults {
        let obj = Object.assign(new ReportsFeatureFlagsWithDefaults(), model);
        ReportsFeatureFlagsWithDefaults.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportsFeatureFlagsWithDefaults>): ReportsFeatureFlagsWithDefaults {
        if (!model) return null;
        return ReportsFeatureFlagsWithDefaults.newInstance(<ReportsFeatureFlagsWithDefaults> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportsFeatureFlagsWithDefaults) {
        if (!obj) return;

        models.ReportsFeatureFlagsWithDefaults.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportsFeatureFlagsWithDefaults): boolean {
        if (models.FeatureFlagsWithDefaults.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ReportsFeatureFlagsWithDefaults.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Flag's default value
     */
    rept_2504_f_test_flag: boolean = false;

}
